import { format, isToday, isYesterday } from "date-fns";

/**
 * Show a timestamp in a human readable format.
 * If the date is today, show "Today" instead of the date.
 * If the date is yesterday, show "Yesterday" instead of the date.
 * Otherwise, show the date in the format "MMM d, h:mm a".
 *
 * @param timestamp - The timestamp to format.
 * @returns A human readable timestamp.
 */
const Timestamp = ({ timestamp }: { timestamp?: Date }) => {
  if (!timestamp) {
    return null;
  }

  const date = new Date(timestamp);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  if (isToday(date)) {
    // "h:mm a"
    return <p>{format(date, "h:mm a")}</p>;
  } else if (isYesterday(date)) {
    // "Yesterday, h:mm a"
    return <p>{`Yesterday, ${format(date, "h:mm a")}`}</p>;
  } else {
    // "MMM d, h:mm a"
    return <p>{format(date, "MMM d, h:mm a")}</p>;
  }
};

export default Timestamp;
